class PathCommand {
    constructor(com, args) {
        this._command = com;
        this._arguments = args !== null && args !== void 0 ? args : [];
    }
    setStart(start) {
        this._startPoint = start;
    }
    setNormals(normals) {
        this._normals = normals;
    }
    toString(decimal) {
        return this._command + " " + this._arguments.map(val => Number(val.toFixed(decimal !== null && decimal !== void 0 ? decimal : 8))).join(" ");
    }
    ;
}
export default PathCommand;
